import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { isObject } from '../../utils/primitive'
import PropTypesHelpers from '../../utils/propTypesHelpers'

export const DefaultTabsContainer = ({ children, ...props }) => <ul className='nav nav-tabs' {...props}>{children}</ul>

DefaultTabsContainer.propTypes = {
  children: PropTypesHelpers.children
}

export const DefaultTag = ({ active, onClick, item, render, ...props }) => (
  <li className='nav-item' {...props}>
    <a href='' className={classnames('nav-link', { active })} onClick={onClick}>
      {render ? render(item, props) : item}
    </a>
  </li>
)
DefaultTag.propTypes = {
  active: PropTypes.bool,
  item: PropTypes.oneOfType([PropTypes.object, PropTypesHelpers.children]),
  render: PropTypes.func,
  onClick: PropTypes.func
}

export const DefaultPage = ({ item, render, ...props }) => <p {...props}>{render ? render(item, props) : item}</p>
DefaultPage.propTypes = {
  item: PropTypes.oneOfType([PropTypes.object, PropTypesHelpers.children]),
  render: PropTypes.func
}

export class TabPager extends Component {
  constructor (props) {
    super(props)

    const { initial: { active = -1 } = {} } = this.props

    this.state = { active: active !== -1 ? active : 0 }

    this.handleItemClick = this.handleItemClick.bind(this)
  }

  handleItemClick (idx, e) {
    e && e.preventDefault()
    if (this.state.active !== idx) {
      this.setState({ active: idx })
      const { onChange, items } = this.props
      if (onChange) {
        onChange(items[idx])
      }
    }
  }

  render () {
    const {
      items,
      tabsContainerTag: TabsContainerTag = DefaultTabsContainer,
      tabsContainerProps,
      tabTag: TabTag = DefaultTag,
      tabProps,
      pageTag: PageTag = DefaultPage,
      pageProps,
      emptyTag: EmptyTag,
      emptyProps
    } = this.props
    const { active } = this.state

    if (!items.length) {
      if (!EmptyTag) return
      return (
        <EmptyTag {...emptyProps} />
      )
    }

    return (
      <>
        <TabsContainerTag {...tabsContainerProps}>
          {items.map((item, idx) => (
            <TabTag
              key={idx}
              {...tabProps}
              {...(isObject(item) ? item : {})}
              item={item}
              active={active === idx}
              onClick={e => this.handleItemClick(idx, e)}
            />
          ))}
        </TabsContainerTag>

        <PageTag {...pageProps} {...(isObject(items[active]) ? items[active] : {})} item={items[active]} />
      </>
    )
  }
}

TabPager.propTypes = {
  initial: PropTypes.shape({
    active: PropTypes.number
  }),
  items: PropTypes.array.isRequired,
  tabsContainerTag: PropTypesHelpers.tag,
  tabsContainerProps: PropTypes.object,
  tabTag: PropTypesHelpers.tag.isRequired,
  tabProps: PropTypes.shape({
    render: PropTypes.func
  }),
  pageTag: PropTypesHelpers.tag.isRequired,
  pageProps: PropTypes.shape({
    render: PropTypes.func
  }),
  emptyTag: PropTypesHelpers.tag,
  emptyProps: PropTypes.object,
  onChange: PropTypes.func
}

export default TabPager
